/**
 * 浏览器端文件下载工具（axios blob 响应 + Content-Disposition）
 */

/**
 * 从响应头 Content-Disposition 解析文件名（常见形式：attachment;filename=xxx）
 * @param {import('axios').AxiosResponse} res axios 响应（需含 headers）
 * @param {string} fallbackName 无头或解析失败时的默认文件名
 * @returns {string}
 */
export function resolveFilenameFromContentDisposition (res, fallbackName) {
  const raw = res.headers && res.headers['content-disposition'];
  const part = raw && typeof raw === 'string' ? raw.split('=')[1] : '';
  try {
    return decodeURI(part || fallbackName);
  } catch (e) {
    return fallbackName;
  }
}

/**
 * 将二进制数据触发为浏览器下载（不经过服务端文件名时可直接传 fileName）
 * @param {BlobPart} data 通常为 res.data（arraybuffer / blob）
 * @param {string} fileName 保存为本地文件时的名称
 */
export function downloadBlobAsFile (data, fileName) {
  const blob = new Blob([data]);
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(link.href);
}

/**
 * 从 axios blob 接口响应一次性完成：解析服务端文件名并下载
 * @param {import('axios').AxiosResponse} res
 * @param {string} fallbackFileName 例如「故障上报单.docx」
 */
export function downloadFromApiBlobResponse (res, fallbackFileName) {
  const fileName = resolveFilenameFromContentDisposition(res, fallbackFileName);
  downloadBlobAsFile(res.data, fileName);
}

/**
 * 为 Blob / 二进制数据创建 Object URL（用于图片预览等；用毕须 URL.revokeObjectURL）
 * @param {BlobPart|Blob} data axios blob 的 res.data 等
 * @param {BlobPropertyBag} [blobOptions] 非 Blob 时传给 new Blob 的选项
 * @returns {string}
 */
export function createObjectUrlFromBlobData (data, blobOptions) {
  const blob = data instanceof Blob ? data : new Blob([data], blobOptions);
  return URL.createObjectURL(blob);
}
